export default __webpack_public_path__ + "static/media/chrome-dark.c933aa30.svg";